<template>
  <div class="authorization-container section-main__warp">
    <!-- 标签 -->
    <div class="type-tab">
      <div
        v-for="item in constData.tabs"
        :key="item.typeId"
        :class="['tab', checkType == item.typeId ? 'active' : '']"
        @click="checkType = item.typeId"
      >
        {{ item.label }}
      </div>
    </div>
    <!-- 内容 -->
    <div class="type-content">
      <div class="content" v-if="checkType == 1">
        <groupAuth></groupAuth>
      </div>
      <div class="content" v-else-if="checkType == 2">
        <personAuth></personAuth>
      </div>
      <div class="content" v-else-if="checkType == 3">
        <typeAuth></typeAuth>
      </div>
    </div>
  </div>
</template>

<script>
import groupAuth from "../components/groupAuth.vue";
import personAuth from "../components/personAuth.vue";
import typeAuth from "../components/typeAuth.vue";
export default {
  components: {
    groupAuth,
    personAuth,
    typeAuth,
  },
  data() {
    return {
      constData: {
        tabs: [
          {
            label: "按群组授权",
            typeId: "1",
          },
          {
            label: "按人员授权",
            typeId: "2",
          },
          {
            label: "按类型授权",
            typeId: "3",
          },
        ],
      },
      checkType: "1",
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.authorization-container {
  width: 100%;
  height: 100%;
  flex-direction: column;

  .type-tab {
    height: 42px;
    line-height: 30px;
    padding: 6px 0;
    display: flex;
    @include set_theme_color(background-color, page-bg-color);

    .tab {
      // color: #9aa6c1;
      flex: 1;
      text-align: center;

      &:hover {
        // @include set_theme_color(color, font-active-color);
        cursor: pointer;
      }
    }

    .active {
      color: #fff;
      @include set_theme_color(background-color, main-theme-color);
    }
  }

  .type-content {
    height: 100%;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;

    .content {
      width: calc(100%);
    }
  }
}
</style>
